<template>
  <div>
    <div>
      <b-row class="col-12">
        <b-form-input
          v-model="search"
          placeholder="Search e-mail"
          type="text"
          @input="records_filter"
          class="col-9" 
          autocomplete="off"
        >
        </b-form-input>
        <b-input-group-text slot="append">
          <b-btn
            variant="link"
            size="sm"
            @click="search = ''"
            class="p-0 i"
          >
          X
          </b-btn>
        </b-input-group-text>
      </b-row>
      <b-table 
        id="records"
        hover
        fixed
        :items="records" 
        :fields="fields"
        :busy="loading"
        :no-local-sorting="true"
        ref="records"
      >
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner variant="primary" class="align-middle"></b-spinner>
          </div>
        </template>
        <template v-slot:cell(actions)="data">
          <b-button v-show="rows>0" variant="danger" class="button" @click.prevent.stop="gdpr_delete(data.item.email)"><span class="icon-eraser mr-2" @click.prevent.stop="gdpr_delete(data.item.email)"></span>Delete</b-button>
        </template>
      </b-table>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
const fields = [
  { key: 'email', label: 'E-mail', sortable: false },
  { key: 'type', label: 'Type', sortable: false },
  { key: 'actions', label: '', sortable: false, tdClass: 'col-2' },
];
export default {
  components: {
  },
  name: 'GDPRErase',
  mounted() {
  },
  data: function() {
    return {
      search: '',
      searching: false,
      searchcalc: false,
      fields: fields,
      records: [],
      currentPage: 1,
      perPage: 10,
      rows: 0,
      loading: null,
    }
  },
  watch: {
    search: function() {
      this.searching = true
      this.records_filter()
    }
  },
  methods: {
    records_filter: _.debounce(function() {
      this.searchcalc = true
      setTimeout(function() {
        this.records_filterget();
        this.searchcalc = false;
        this.searching = false;
      }.bind(this),500)
    },300),
    records_filterget() {
      this.currentPage = 1;
      this.records_get();
    },
    records_get() {
      this.records = [];
      if (this.search == '') { return; }
      this.loading = true;
      this.$store.dispatch('gdpr_fetch', {
        search: this.search,
      })
      .then((resp) => {
         for (var i=0;i<resp.data.result.length;i++) {
           var result = {
             email: resp.data.result[i].email,
             type: resp.data.result[i].type,
           }
           this.records.push(result);
         }
         this.rows = resp.data.total;
         this.loading = false;
      });
    },
    gdpr_delete(email) {
      this.loading = true;
      this.$store.dispatch('gdpr_delete' , { email: email })
      .then(() => {
        this.loading = false;
        this.records_get();
      });
    },
  },
}
</script>
<style>
</style>
